import {CustomMarkers} from "@/lib/editor";
import {parse} from '@prantlf/jsonlint'
/**
 *
 * @param error - Example "error on line 7 at column 8: Opening and ending tag mismatch: to line 3 and note"
 */
const getMarkerDetails = (error: any): {line: number; column: number} => {
    const line = error.location.start.line;
    const column = error.location.start.column;
    return {line, column }
}

export const validateJSON = (jsonText: string): Array<CustomMarkers> | undefined => {
    try{
        parse(jsonText);
    }
    catch (e: any) {
        const markers =getMarkerDetails(e)
        return [{message: e.reason, ...markers}];
    }

}

/**
 * True when the quote at `index` is escaped, meaning an odd number of backslashes precedes it. Counting them matters:
 * in `"a\\\\"` the quote after two backslashes closes the string, which checking only the previous character gets wrong.
 */
const isEscapedQuote = (text: string, index: number): boolean => {
    let backslashes = 0;
    while (index - 1 - backslashes >= 0 && text.charAt(index - 1 - backslashes) === "\\") {
        backslashes += 1;
    }
    return backslashes % 2 === 1;
};

/**
 * Removes every space, tab and line break that sits outside a string and leaves everything else untouched, so the
 * data is identical and only the size changes. It does not parse the text, which keeps long numbers such as
 * 12345678901234567890 and the key order exactly as written (a JSON.parse/stringify round trip would change both).
 * Callers validate first: on invalid JSON the output is just the input with whitespace removed.
 */
export const JSONMinifier = (json: string): string => {
    let minified = "";
    let inString = false;
    for (let i = 0; i < json.length; i += 1) {
        const currentChar = json.charAt(i);
        if (currentChar === '"' && !isEscapedQuote(json, i)) {
            inString = !inString;
        }
        const isWhitespace = currentChar === " " || currentChar === "\n" || currentChar === "\r" || currentChar === "\t";
        if (inString || !isWhitespace) {
            minified += currentChar;
        }
    }
    return minified;
};

function repeat(s: string, count: number) {
    return new Array(count + 1).join(s);
}

export const JSONFormatter = (json:string) => {
    let i           = 0,
        il          = 0,
        tab         = "  ",
        newJson     = "",
        indentLevel = 0,
        inString    = false,
        currentChar = null;

    for (i = 0, il = json.length; i < il; i += 1) {
        currentChar = json.charAt(i);

        switch (currentChar) {
            case '{':
            case '[':
                if (!inString) {
                    newJson += currentChar + "\n" + repeat(tab, indentLevel + 1);
                    indentLevel += 1;
                } else {
                    newJson += currentChar;
                }
                break;
            case '}':
            case ']':
                if (!inString) {
                    indentLevel -= 1;
                    newJson += "\n" + repeat(tab, indentLevel) + currentChar;
                } else {
                    newJson += currentChar;
                }
                break;
            case ',':
                if (!inString) {
                    newJson += ",\n" + repeat(tab, indentLevel);
                } else {
                    newJson += currentChar;
                }
                break;
            case ':':
                if (!inString) {
                    newJson += ": ";
                } else {
                    newJson += currentChar;
                }
                break;
            case ' ':
            case "\n":
            case "\r":
            case "\t":
                if (inString) {
                    newJson += currentChar;
                }
                break;
            case '"':
                if (!isEscapedQuote(json, i)) {
                    inString = !inString;
                }
                newJson += currentChar;
                break;
            default:
                newJson += currentChar;
                break;
        }
    }

    return newJson;
}
